/* eslint-disable default-case, no-param-reassign */
/*
 *
 * GoldRedirect reducer
 *
 */

import produce from 'immer';

import {
  CHANGE_INPUT_VALUE,
  GOLD_MIGRATION_LOGIN_REQUEST,
  GOLD_MIGRATION_LOGIN_REQUEST_FAILURE,
  GOLD_MIGRATION_LOGIN_REQUEST_SUCCESS,
  RESET_FORM_ERRORS,
  SET_GOLD_MIGRATION_COOKIES,
  UPDATE_GOLD_MIGRATION_SESSION,
  UPDATE_IS_USERNAME_REQUIRED,
  UPDATE_PROFILE_TRANSFER_STEP,
} from './constants';

export const initialState = {
  cookies: {
    goldMigrationPLGeneralLogin: false,
    goldMigrationPLPreLogin: false,
    goldMigrationPLProfileTransfer: false,
  },
  error: {
    login: false,
    session: false,
  },
  formErrors: {
    profileTransfer: {
      confirmPassword: '',
      password: '',
      username: '',
    },
  },
  formValues: {
    profileTransfer: {
      confirmPassword: '',
      password: '',
      username: '',
    },
  },
  profileTransferStep: 1,
  session: {},
  status: { login: 'idle' },
  success: false,
};

const goldRedirectReducer = produce((draft, { payload, type }) => {
  switch (type) {
    case CHANGE_INPUT_VALUE: {
      const { field, value } = payload;
      draft.formValues.profileTransfer[field] = value;
      if (draft.formErrors.profileTransfer[field]) {
        draft.formErrors.profileTransfer[field] = '';
      }
      break;
    }
    case GOLD_MIGRATION_LOGIN_REQUEST: {
      draft.error.login = false;
      draft.status.login = 'loading';
      break;
    }
    case GOLD_MIGRATION_LOGIN_REQUEST_FAILURE: {
      const { formErrors, fullError } = payload;
      if (fullError) {
        draft.error.login = fullError;
        draft.status.login = 'failed';
      } else if (formErrors) {
        formErrors.forEach(({ key, message }) => {
          draft.formErrors.profileTransfer[key] = message;
        });
        draft.status.login = 'idle';
      }
      break;
    }
    case GOLD_MIGRATION_LOGIN_REQUEST_SUCCESS: {
      draft.status.login = 'succeeded';
      break;
    }
    case RESET_FORM_ERRORS: {
      draft.formErrors = initialState.formErrors;
      break;
    }
    case SET_GOLD_MIGRATION_COOKIES: {
      const {
        goldMigrationPLGeneralLogin,
        goldMigrationPLPreLogin,
        goldMigrationPLProfileTransfer,
      } = payload;
      draft.cookies = {
        goldMigrationPLGeneralLogin,
        goldMigrationPLPreLogin,
        goldMigrationPLProfileTransfer,
      };
      if (goldMigrationPLProfileTransfer === 'ERROR') {
        draft.profileTransferStep = 4;
      }
      break;
    }
    case UPDATE_IS_USERNAME_REQUIRED: {
      draft.session.isUsernameRequired = payload;
      break;
    }
    case UPDATE_GOLD_MIGRATION_SESSION: {
      const {
        goldMigrationPLSession,
        goldMigrationPLSessionError,
      } = payload;
      if (goldMigrationPLSessionError) {
        draft.profileTransferStep = 4;
      }
      draft.error.session = goldMigrationPLSessionError;
      draft.session = goldMigrationPLSession;
      break;
    }
    case UPDATE_PROFILE_TRANSFER_STEP: {
      const { step } = payload;
      draft.profileTransferStep = step;
      break;
    }
  }
}, initialState);

export default goldRedirectReducer;
